import { render, staticRenderFns } from "./DetailQuotaModal.vue?vue&type=template&id=33a3a036&scoped=true&"
import script from "./DetailQuotaModal.vue?vue&type=script&lang=js&"
export * from "./DetailQuotaModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuotaModal.vue?vue&type=style&index=0&id=33a3a036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3a036",
  null
  
)

export default component.exports